<!-- eslint-disable -->
<template>
  <div class="member-menu" style="width:400px;over">
    <a-spin :spinning="listLoading">
      <div class="search-content">
        <a-input v-model="keyword" placeholder="搜索标签" @keyup.enter.native="addNotes" v-if="form == 'company'">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-input v-model="keyword" placeholder="搜索标签" v-else>
          <a-icon slot="prefix" type="search" />
        </a-input>
      </div>
      <div class="member-list tag-list" style="padding: 0 5px;overflow: auto;">
        <div
          class="tag_box tag_blue"
          v-for="(item, index) in list"
          :key="index"
          style="margin:5px;"
          :class="{ checkfield: showCheck(item) }"
          @click.stop="setTag(item)"
        >
          {{ item.name }}
        </div>
        <!-- <vue-scroll>
                    <div class="list-group">
                        <a-list
                                class="list-content"
                                itemLayout="horizontal"
                                :dataSource="list"
                                :locale="{emptyText: (keyword && keyword.length > 1) ? '没有该标签,回车可添加' : ''}"
                        >
                            <a-list-item class="member-list-item" slot="renderItem" slot-scope="item,index"
                                          @click.native="setTag(item)">
                                <span slot="actions">
                                    <a-icon type="check" class="m-l-sm" v-show="showCheck(item)"></a-icon>
                                  </span>
                                <a-list-item-meta>
                                <span class="tag-title" slot="title"> <a-badge status="success"/> {{item.name}}</span>
                                </a-list-item-meta>
                            </a-list-item>
                        </a-list>
                    </div>
                </vue-scroll> -->
      </div>
      <div class="footer tag_foot" style="margin-left: -125px;left: 50%;">
        <a-button type="primary" class="tag_btn" @click="saveTags">保存</a-button>
      </div>
    </a-spin>
  </div>
</template>

<script>
/* eslint-disable */

import tag from 'components/base/tag'
import { tagList, tagAction } from '@/api/tags'
import { changeTagIds } from '@/api/work'

export default {
  components: { tag },
  props: {
    taglist: {
      type: Array,
      default() {
        return []
      }
    },
    form: {
      type: String,
      default: 'notes'
    }
  },
  data() {
    return {
      keyword: '',
      creating: false, //创建标签状态
      activeCreating: false, //是否手动发起的创建（搜索结果为空时，也会发起创建，但不属于手动发起）
      listLoading: false,
      list: [],
      listCopy: [],
      listTemp: [],
      currentBadge: 'blue',
      currentTag: {
        tag: null,
        index: -1
      }
    }
  },
  created() {
    this.listTemp = JSON.parse(JSON.stringify(this.taglist)) || []
    this.init()
  },
  watch: {
    keyword() {
      this.search()
    },
    taglist() {
      this.listTemp = JSON.parse(JSON.stringify(this.taglist)) || []
    }
  },
  methods: {
    init() {
      this.listLoading = true
      tagList(this.form).then(res => {
        this.list = res.data
        this.listCopy = res.data
        this.listLoading = false
      })
    },
    showCheck(tag) {
      const index = this.listTemp.findIndex(item => item.id == tag.id)
      return index !== -1
    },
    checkTaskChange(tag) {
      const index = this.listTemp.findIndex(item => item.id == tag.id)
      if (index !== -1) {
        this.listTemp.splice(index, 1)
      } else {
        this.listTemp.push(tag)
      }
    },
    setTag(tag) {
      this.checkTaskChange(tag)
    },
    saveTags() {
      if (this.form == 'notes') {
        this.$emit('change', this.listTemp)
      } else {
        let tagIds = []
        this.listTemp.forEach(item => {
          tagIds.push(item.id)
        })
        changeTagIds({ companyId: this.$route.query.id, tagIds: tagIds.join(',') }).then(res => {
          this.$emit('update')
        })
      }
    },
    search() {
      this.keyword = this.keyword.trim()
      if (!this.keyword) {
        this.list = JSON.parse(JSON.stringify(this.listCopy))
      }
      this.list = this.list.filter(item => item.name.indexOf(this.keyword) != -1)
    },
    addNotes() {
      if (this.form == 'company' && this.list.length == 0) {
        tagAction('company', { name: this.keyword }).then(res => {
          tagList(this.form).then(res => {
            if (res.code === 200) {
              this.list = res.data
              this.listCopy = res.data
              // this.list = this.list.filter(item => item.name.indexOf(this.keyword) != -1);
            }
          })
        })
      }
    }
  }
}
</script>
<style lang="less">
@import url('./memberMenu.less');
.tag_foot {
  display: flex;
  .tag_btn {
    flex: 1;
    margin: 0 10px;
  }
}
</style>
